/* eslint-disable */
<template>
  <transition name="slide" enter-active-class="slideInRight" leave-active-class="slideOutRight">
    <v-navigation-drawer
        id="large-slideout"
        v-model="slideOutLarge.toggle"
        fixed
        :stateless="['rubric'].includes(slideOutLarge.view || '')"
        touchless
        temporary
        right
        :width="navigationDrawerWidth">
        
      <div v-if="slideOutLarge.view === 'profile'">
        <div class="branded-background slideout-heading" >
          <div class="row-center">
            <h2 class="text-white">User Profile</h2>
            <a :href=profileSrc target="_blank" style="text-decoration:none; margin-left:32px;">
              <v-icon color="white">launch</v-icon>
            </a>
          </div>
          <v-btn icon @click="slideclose" tabindex="0" :aria-label="`Close ${slideOutLarge.view} slide out.`">
            <v-icon color="white">
              close
            </v-icon>
          </v-btn>
        </div>
        <iframe
          id="profileIframe"
          :src=profileSrc
          class="iframe-fit"
          tabindex="0">
        </iframe>
      </div>

      <div v-if="slideOutLarge.view === 'activityfeed'">
        <div class="branded-background slideout-heading">
          <div class="row-center">
            <h2 class="text-white">Activity Feed</h2>
            <a :href=activityFeedSrc target="_blank" style="text-decoration:none; margin-left:32px;" :aria-label="`Open ${slideOutLarge.view} in another tab.`">
              <v-icon color="white">launch</v-icon>
            </a>
          </div>
          <v-btn icon @click="slideclose" tabindex="0" :aria-label="`Close ${slideOutLarge.view} slide out.`">
            <v-icon color="white">
              close
            </v-icon>
          </v-btn>
        </div>
        <iframe
          id="feedIframe"
          :src=activityFeedSrc
          class="iframe-fit"
          tabindex="0">
        </iframe>
      </div>

      <div v-if="slideOutLarge.view === 'student'" class="iframe">
        <div class="branded-background slideout-heading"></a>
          <div class="row-center">
            <h2 class="text-white">Add Learners</h2>
              <a :href=studentSrc target="_blank" style="text-decoration:none; margin-left:32px;">
                 <v-icon color="white" >launch</v-icon>
              </a>
          </div>
          <v-icon
            color="white"
            tabindex="0"
            @click="slideclose"
            >close</v-icon>
        </div>
        <iframe
          tabindex="0"
          :src=studentSrc
          class="iframe-fit"
          allow="clipboard-read; clipboard-write">
        </iframe>
      </div>

      <div v-if="slideOutLarge.view === 'rubric'" class="iframe">
        <div class="width-100 full-height">
          <playposit-rubric
            title="Rubric Designer"
            :button-action="rubric_options.edit ? 'save' : 'next'"
            :lti="LTIlaunch"
            :save-toggle="rubricSaveToggle"
            v-bind="rubric_options"
            @exit="closeRubric"
            @next="rubricNext"
            @is-rubric-valid="handleRubricValidityChange"
            @error="handleError">
          </playposit-rubric>
        </div>
        <!-- <div class="slideout-footer">
          <v-btn block class="full-height my-0 branded-background text-white" @click="rubricNext" :disabled="!rubricValid" v-if="!rubric_options.edit">
            Next
          </v-btn>
          <v-btn block class="full-height my-0 branded-background text-white" @click="closeRubric" :disabled="!rubricValid" v-if="rubric_options.edit">
            Save
          </v-btn> -->
      </div>

     <div
      v-if="slideOutLarge.view === 'peer-review'"
      class="peer-review-slideout"
    >
      <div class="branded-background slideout-heading">
        <div class="row-center">
          <v-icon
            color="white"
            style="padding-right: 8px"
            >dns</v-icon
          >
          <h2 class="text-white">
            Grading Rubrics for {{slideOutLarge.data.student_name}}
          </h2>
        </div>
        <v-icon
          color="white"
          @click="slideclose"
          >close</v-icon
        >
      </div>
      <div>
        <v-tabs
          v-model="lmbtab"
          grow
        >
          <v-tab> Instructor Feedback </v-tab>
          <v-tab> Feedback Received </v-tab>
          <v-tab> Feedback Given </v-tab>
        </v-tabs>
        <v-tabs-items v-model="lmbtab">
          <!-- Instructor Feedback  -->
          <v-tab-item :key="0">
            <div
              class="column"
              style="width: 100%; height: 100px"
            >
              <v-btn
                class="branded-background text-white"
                @click="evaluatePeerReview"
                :disabled="evaluatePeerReviewText === 'Evaluate'"
              >
                {{ evaluatePeerReviewText }}
              </v-btn>
            </div>
            <div class="peer-review-table-instructor">
              <el-table
                :data="peerReviewRubric.instructor"
                height="250px"
              >
                <el-table-column
                  align="center"
                  prop="teacher_name"
                  label="Instructor Name"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.teacher_name }}</span>
                    <span
                      v-if="scope.row.bulbattempt_id === syncedScoreId"
                      style="font-size: 18px; margin-left: 4px"
                    >
                      *
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="score"
                  width="150"
                  label="Score"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="status"
                  width="215"
                  label="Status"
                >
                  <template slot-scope="scope">
                    <el-tag
                      v-if="!scope.row.complete && scope.row.complete != 0"
                      type="info"
                      >{{scope.row.status}}</el-tag
                    >
                    <el-tag
                      v-if="scope.row.complete === 0"
                      type="warning"
                      >{{scope.row.status}}</el-tag
                    >
                    <el-tag
                      v-if="scope.row.complete === 1"
                      type="success"
                      >{{scope.row.status}}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop=""
                  width="100"
                  label="Rubric"
                >
                  <template slot-scope="scope">
                    <v-menu
                      offset-y
                      v-if="scope.row.bulbattempt_id != null && scope.row.complete === 1"
                      v-model="menus.instructorFeedbackRubric[scope.row.id]"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          color="primary"
                          dark
                          flat
                          icon
                        >
                          <v-icon>dns</v-icon>
                        </v-btn>
                      </template>
                      <div
                        style="width: 450px; height: 400px; overflow: scroll"
                        class="white"
                      >
                        <h1
                          tabindex="0"
                          aria-label="Bulb title: Rubric View"
                          class="headline primary white--text interaction-review-title py-3 px-2 mb-3 text-xs-center"
                        >
                          Rubric View
                        </h1>
                        <template
                          v-if="menuData.instructorFeedbackRubric[scope.row.id]"
                        >
                          <PlaypositInteraction
                            v-for="rubricInteraction in finalizedRubricInteractions"
                            :key="rubricInteraction.id"
                            :bulb-id="parseInt(slideOutLarge.data.lmb_id, 10)"
                            :section-id="parseInt(slideOutLarge.data.lmb_section_id, 10)"
                            :student-id="parseInt(scope.row.id, 10)"
                            :interactionId="parseInt(rubricInteraction.id, 10)"
                            :token="instructorData.token"
                            :restrict-discussion-comments-by-student-id="scope.row.id"
                            user-type="teacher"
                            discussion-role="observer"
                            perspective="answered"
                          />
                        </template>
                      </div>
                    </v-menu>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop=""
                  width="150"
                >
                  <template
                    slot="header"
                    slot-scope="scope"
                  >
                    <div class="interaction-question-icon">
                      <v-icon
                        class="icon-light"
                        :size="18"
                      >
                        chat
                      </v-icon>
                      <span class="caption">00:00:00</span>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <v-menu
                      offset-y
                      min-width="350px"
                      max-width="350px"
                      :close-on-content-click="false"
                      v-model="menus.instructorFeedbackDiscussion[scope.row.id]"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          v-on="on"
                          :disabled="scope.row.bulbattempt_id === null"
                          flat
                          icon
                        >
                          <v-icon>chat</v-icon>
                        </v-btn>
                      </template>
                      <div>
                        <div class="question_header">
                          <v-icon color="white">chat</v-icon>
                          <span>00:00:00</span>
                        </div>
                        <PlaypositInteraction
                          v-if="menuData.instructorFeedbackDiscussion[scope.row.id]"
                          :bulb-id="parseInt(peerReviewBulbId, 10)"
                          :section-id="parseInt(slideOutLarge.data.lmb_section_id, 10)"
                          :student-id="parseInt(scope.row.id, 10)"
                          :interactionId="parseInt(peerReviewRubric.discussion.id, 10)"
                          :token="instructorData.token"
                          :restrict-discussion-comments-by-student-id="scope.row.id"
                          user-type="teacher"
                          discussion-role="observer"
                          perspective="answered"
                        />
                      </div>
                    </v-menu>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="padding: 4px 24px">
              <span style="font-size: 18px">*</span><span>Synced score</span>
            </div>
          </v-tab-item>
          <!-- Feedback Recieved -->
          <v-tab-item :key="1">
            <div class="peer-review-table">
              <el-table
                :data="peerReviewRubric.view"
                height="350px"
              >
                <el-table-column
                  align="center"
                  prop="student_name"
                  label="Learner Name"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="score"
                  width="150"
                  label="Score"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="status"
                  width="275"
                  label="Status"
                >
                  <template slot-scope="scope">
                    <el-tag
                      v-if="!scope.row.complete && scope.row.complete != 0"
                      type="info"
                      >{{scope.row.status}}</el-tag
                    >
                    <el-tag
                      v-if="scope.row.complete === 0"
                      type="warning"
                      >{{scope.row.status}}</el-tag
                    >
                    <el-tag
                      v-if="scope.row.complete === 1"
                      type="success"
                      >{{scope.row.status}}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop=""
                  width="100"
                  label="Rubric"
                >
                  <template slot-scope="scope">
                    <v-menu
                      v-if="(
                        scope.row.bulbattempt_id != null
                        && scope.row.complete === 1
                      )"
                      v-model="menus.receivedFeedbackRubric[scope.row.id]"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          v-on="on"
                          flat
                          icon
                        >
                          <v-icon>dns</v-icon>
                        </v-btn>
                      </template>
                      <div style="width: 450px; height: 400px; overflow: scroll">
                        <h1
                          tabindex="0"
                          aria-label="Bulb title: Rubric View"
                          class="headline primary white--text interaction-review-title py-3 px-2 mb-3 text-xs-center"
                        >
                          Rubric View
                        </h1>
                        <template
                          v-if="menuData.receivedFeedbackRubric[scope.row.id]"
                        >
                          <PlaypositInteraction
                            v-for="rubricInteraction in finalizedRubricInteractions"
                            :key="rubricInteraction.id"
                            :bulb-id="parseInt(slideOutLarge.data.lmb_id, 10)"
                            :section-id="parseInt(slideOutLarge.data.lmb_section_id, 10)"
                            :student-id="parseInt(scope.row.id, 10)"
                            :interactionId="parseInt(rubricInteraction.id, 10)"
                            :token="instructorData.token"
                            :restrict-discussion-comments-by-student-id="scope.row.id"
                            user-type="teacher"
                            discussion-role="observer"
                            perspective="answered"
                          />
                        </template>
                      </div>
                    </v-menu>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop=""
                  width="150"
                >
                  <template
                    slot="header"
                    slot-scope="scope"
                  >
                    <div class="interaction-question-icon">
                      <v-icon
                        class="icon-light"
                        :size="18"
                      >
                        chat
                      </v-icon>
                      <span class="caption">00:00:00</span>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <v-menu
                      offset-y
                      min-width="350px"
                      max-width="350px"
                      :close-on-content-click="false"
                      v-model="menus.receivedFeedbackDiscussion[scope.row.id]"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          v-on="on"
                          :disabled="scope.row.bulbattempt_id === null"
                          flat
                          icon
                        >
                          <v-icon>chat</v-icon>
                        </v-btn>
                      </template>
                      <div>
                        <div class="question_header">
                          <v-icon color="white">chat</v-icon>
                          <span>00:00:00</span>
                        </div>
                        <PlaypositInteraction
                          v-if="menuData.receivedFeedbackDiscussion[scope.row.id]"
                          :bulb-id="parseInt(peerReviewBulbId, 10)"
                          :section-id="parseInt(slideOutLarge.data.lmb_section_id, 10)"
                          :student-id="parseInt(scope.row.id, 10)"
                          :interactionId="parseInt(peerReviewRubric.discussion.id, 10)"
                          :token="instructorData.token"
                          :restrict-discussion-comments-by-student-id="scope.row.id"
                          user-type="teacher"
                          discussion-role="observer"
                          perspective="answered"
                        />
                      </div>
                    </v-menu>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </v-tab-item>
          <!-- Feedback Given -->
          <v-tab-item :key="2">
            <div class="peer-review-table">
              <el-table
                :data="peerReviewRubric.give"
                height="350px"
              >
                <el-table-column
                  prop="thumbnail"
                  label=""
                  align="center"
                  width="80"
                >
                  <template slot-scope="scope">
                    <div
                      class="column"
                      style="height: 50px"
                    >
                      <v-responsive
                        :aspect-ratio="16/9"
                        height="36px"
                        width="64px"
                        max-height="36px"
                        max-width="64px"
                      >
                        <div
                          class="thumbnail-wrapper-nonselect"
                          :style="thumbnailStyle(scope.row.thumbnail)"
                        ></div>
                      </v-responsive>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="student_name"
                  label="Learner Name"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="points"
                  width="150"
                  label="Points"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="score"
                  width="150"
                  label="Score"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="status"
                  width="275"
                  label="Status"
                >
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.lmb_id === null"
                      type="info"
                      >{{scope.row.status}}</el-tag
                    >
                    <el-tag
                      v-if="!scope.row.complete && scope.row.complete != 0 && scope.row.lmb_id != null"
                      type="danger"
                      >{{scope.row.status}}</el-tag
                    >
                    <el-tag
                      v-if="scope.row.complete === 0"
                      type="warning"
                      >{{scope.row.status}}</el-tag
                    >
                    <el-tag
                      v-if="scope.row.complete === 1"
                      type="success"
                      >{{scope.row.status}}</el-tag
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>

      <BatchCopy v-if="slideOutLarge.view === 'batchCopy'" :bulbs="slideOutLarge.bulbs"></BatchCopy>
      <BatchSettings v-if="slideOutLarge.view === 'batchSettings'" :bulbs="slideOutLarge.bulbs"></BatchSettings>
      <Groups v-if="slideOutLarge.view === 'groups'" :sectionId="slideOutLarge.sectionId" :initialTab="slideOutLarge.initialTab"></Groups>
      <InteractionData
        v-if="slideOutLarge.view === 'interactionData'"
        :interaction="slideOutLarge.data.interaction"
        :sectionId="slideOutLarge.data.sectionId"
        :html="slideOutLarge.data.interactionHtml">
      </InteractionData>

    </v-navigation-drawer>
  </transition>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapMutations,
  mapState,
  } from 'vuex';
import BatchCopy from './modal-views/batch-copy/BatchCopy';
import BatchSettings from './modal-views/BatchSettings';
import Discussion from './Discussion';
import Groups from './modal-views/groups/Groups';
import InteractionData from './modal-views/InteractionData';

import Accessibility from '@/components/mixins/Accessibility';
import * as focusTrap from 'focus-trap';


export default {
  name: 'slide-out-large',
  components: {
    BatchCopy,
    BatchSettings,
    Discussion,
    Groups,
    InteractionData,
  },
  data() {
    return {
      selected: '',
      rubricValid: true,
      rubricSaveToggle: false,
      lmbtab: 0,
      navigationDrawerWidth: 900,
      menus: {
        instructorFeedbackRubric: {},
        instructorFeedbackDiscussion: {},
        receivedFeedbackRubric: {},
        receivedFeedbackDiscussion: {},
      },
      menuData: {
        instructorFeedbackRubric: {},
        instructorFeedbackDiscussion: {},
        receivedFeedbackRubric: {},
        receivedFeedbackDiscussion: {},
      },
      trap: null,
    };
  },
  mixins: [
    Accessibility,
  ],
  computed: {
    ...mapState([
      'lti13Launch',
    ]),
    ...mapGetters([
      'serverURL',
      'instructorData',
      'learnerData',
      'slideOutLarge',
      'username',
      'triggerRefresh',
      'LTIlaunch',
      'nodeApiPrefix',
      'rubric_lmb_data',
      'rubric_options',
      'popoverToggles',
      'playerApiPrefix',
      'school'
    ]),
    ...mapGetters('instructors',[
      'queryParamsInstructors',
      'activeViewInstructor',
      'peerreview',
    ]),
    ...mapGetters('learners',[
      'peerReviewRubric'
    ]),
   profileSrc: function() {
     return `${this.$inDevEnvironment() ? `${this.nodeApiPrefix}/` : '/'}user-profile?token=${this.instructorData.token}`;
   },
   /**
    * Generate the URL to render the feed microservice into the slide out vue.
    */
   activityFeedSrc: function() {
     this.navigationDrawerWidth = 543;
     return `${this.$inDevEnvironment() ? `${this.nodeApiPrefix}/` : '/'}feed?token=${this.instructorData.token}`;
   },
   studentSrc: function() {
     //computer student uploader url with token
     return `${this.nodeApiPrefix}/csvuploader?token=${this.instructorData.token}&section_id=${this.queryParamsInstructors.section_id}&teacher_id=${this.instructorData.id}`;
   },
   evaluatePeerReviewText: function(){
     if(this.peerReviewRubric.instructor.length >0){
       let text;
       this.peerReviewRubric.instructor.forEach(item => {
         if(item.teacher_id === this.instructorData.id ){
           if(item.complete === null || item.complete === 0){
             text = 'Evaluate Submission'
           } else if(item.teacher_id === this.instructorData.id && item.complete === 1)  {
             text = 'View Submission'
           } else {
             text = 'Evaluate'
           }
         }
       })
       return text;
     } else {
       return 'Evaluate'
     }
   },
   syncedScoreId: function(){
     let id = 0;
     if(this.peerReviewRubric.instructor.length > 0){
       let sortedTeacherAttempts = _.sortBy(this.peerReviewRubric.instructor, 'completionTime');
       id = sortedTeacherAttempts[0].bulbattempt_id;
       return id;
     } else {
       return id
     }
   },
   finalizedRubricInteractions() {
     return _(_.get(this, 'peerReviewRubric.interactions', []))
       .filter((interaction) => interaction.interactionType !== 'discussion_q')
       .orderBy('displayInTime', 'ASC')
       .value();
   },
   peerReviewBulbId() {
     return _.get(this, 'peerReviewRubric.interactions[0].bulbId');
   },
  },
  methods:{
    ...mapMutations([
      'handleDialogOpen'
    ]),
    ...mapActions([
    ]),
    getData: function(){
      if(this.slideOutLarge.view === 'peer-review'){
        this.$store.dispatch('learners/getPeerReviewAssignments', { bulb_id: this.peerreview.headers.id, section_id: this.queryParamsInstructors.section_id, student_id: this.slideOutLarge.data.id});
        this.$store.dispatch('learners/getPeerReviewFeedback', { bulb_id: this.peerreview.headers.id, section_id: this.queryParamsInstructors.section_id, lmb_id: this.slideOutLarge.data.lmb_id, lmb_section_id: this.slideOutLarge.data.lmb_section_id, anonymous: false, rubric:this.peerreview.headers.config.lmb.pr_rubric, student_id: this.slideOutLarge.data.id});
      }
    },
    slideclose: function() {
      //closes slide out menu
      this.setAriaHidden(document.getElementsByClassName('BeaconFabButtonFrame')[0], false);
      this.$store.commit('slideOut', {toggle: false, view: null});
      if(this.activeViewInstructor === 'Peer-Review'){
        this.$store.dispatch('instructors/getTableData');
      }
    },
    listenForMessages: function(){
      //creates listener for post message from teacher uploader
      window.addEventListener("message", this.receivemessage);
    },
    receivemessage: function(event){
      //handles post message from teacher uploader and triggers data refresh
      if(event.data.cmd === "updated" && this.slideOutLarge.view === 'instructor') {
        this.$store.commit('admin/triggerRefresh');
      }
      if(event.data.cmd === "updated" && this.slideOutLarge.view === 'rubric') {
        //update rubric_id here
        // this.$store.commit('setRubricId', event.data.id)
      }

    },
    closeRubric: function(interactions){
     this.$store.commit('saveRubricInteractions', interactions)
     this.slideclose();
     //if not in editing mode, open up warning confirmation at close
     if(!this.rubric_options.edit){
       this.popoverToggles.lmbRubric = false;
       this.handleDialogOpen({type:'confirm', data:{type:'rubric'}})
     }
    },
    rubricNext: function(interactions){
     this.$store.commit('saveRubricInteractions', interactions)
     this.$store.commit('rubricNext');
    },
    handleRubricValidityChange:function(boolean){
      this.rubricValid = boolean;
    },
    handleError: function(err) {
      this.$store.commit('triggerSnackbar', {text:'Adding rubric interaction did not work at this time', color:'red', timeout:6000})
    },
    thumbnailStyle:function(url){
      return {
        backgroundImage: `url("${url}")`
      }
    },
    evaluatePeerReview: function() {
      if(this.evaluatePeerReviewText === 'Evaluate Submission') {
        if (this.learnerData.token) {
          window.open(`${this.playerApiPrefix}/player_v2/?section_id=${this.slideOutLarge.data.lmb_section_id}&type=bulb&bulb_id=${this.slideOutLarge.data.lmb_id}&token=${this.learnerData.token}&lms_launch=${this.LTIlaunch}${this?.lti13Launch ? `&lti13Launch=true` : ''}`);
        } else {
          this.$store.dispatch('instructors/evaluatePeerReview', {
            lmb_id: this.slideOutLarge.data.lmb_id,
            lmb_section_id: this.slideOutLarge.data.lmb_section_id,
          });
        }
        this.slideclose();
      } else {
        window.open(`${this.playerApiPrefix}/player_v2/?section_id=${this.slideOutLarge.data.lmb_section_id}&type=bulb&bulb_id=${this.slideOutLarge.data.lmb_id}&token=${this.learnerData.token}&lms_launch=${this.LTIlaunch}${this?.lti13Launch ? `&lti13Launch=true` : ''}`);
      }
    },
    async setupFocusTrap() {
      await this.$nextTick();
      const slideoutAside = document.getElementById('large-slideout');
      this.trap = focusTrap.createFocusTrap(slideoutAside, {
        clickOutsideDeactivates: true,
        escapeDeactivates: true,
      });
      this.trap.activate();
    },
    removeFocusTrap() {
      this.trap.deactivate();
    },
  },
  watch: {
    menus: {
      handler(n, o) {
        for (const key in n) {
          for (const innerKey in n[key]) {
            if (n[key][innerKey]) {
              this.menuData[key][innerKey] = true;
            }
          }
        }
      },
      deep: true,
    },
    'slideOutLarge.toggle'(newValue, oldValue) {

    },
  },
  mounted() {
    //add update event listener on mount
    this.listenForMessages();
    this.getData();
    this.setupFocusTrap();
    if (
      this.slideOutLarge.view === 'interactionData'
      && !['multiple_choice', 'check_all_apply', 'poll_q', 'discussion_q'].includes(this.slideOutLarge?.data?.interaction?.interaction_type)) this.navigationDrawerWidth = 450;
  },
  beforeDestroy() {
    //destroy event listener
    window.removeEventListener('message', this.receivemessage);
    this.rubricSaveToggle = !this.rubricSaveToggle;
    this.removeFocusTrap();
  }
};
</script>

<style scoped>
@keyframes slideInRight {
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}

.slideInRight {
  animation-name: slideInRight;
  animation-duration: .7s;
}

@keyframes slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(100%, 0, 0);
  }
}

.slideOutRight {
  animation-name: slideOutRight;
  animation-duration: .7s;
}

</style>
